const initialState = {
    info: {
        lotSize: '',
        baths: '',
        bathsAll:'',
        bedrooms: '',
        address: {
            full: '',
            city: '',
            state: '',
            street: '',
            zip: ''
        },
        description: '',
        descriptionPlain: '',
        title: '',
        price: {
            type: '',
            value: 0,
            from: 0,
            to: 0
        },
        sqft: {
            type: '',
            value: 0,
            from: 0,
            to: 0
        },
        propertyType: '',
        listingType: '',
        listingId: '',
        listingStatus: '',
        basementType: '',
        garageBays: '',
        additionalGarageBays: '',
        halfBath: ''
    },
    features: {
        exterior: {},
        interior: {}
    },
    additionalResources: [],
    documents: [],
    disclaimer: ''
};
const property = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state
    }
}

export default property;
